import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL_ONLINEINQUIRY;


const httpClient = axios.create({
  timeout: 120000
});

httpClient.interceptors.response.use(
  response => response,
  error => {
    errorInterceptor(error);
    return Promise.reject(error); 
  }
);

const errorInterceptor = error => {
      if (error && !error.response) {
        if (error.code === "ECONNABORTED") {
          error.response = {
            data: {
              isSucess: false,
              errors: {
                Files: [
                  "Request has timed out. Please try again, if issue persists then call our support team"
                ]
              }
            }
          };
        }
      }
      return Promise.reject(error);
};

export default {
  healthCheck() {
    return httpClient.get(baseUrl);
  },

  submit(payload) {
    return httpClient.post(baseUrl + '/create', payload);
  },

  fetchDepartments() {
    return httpClient.get(baseUrl + '/departments');
  }
};